import { QuestionOption } from '@/types';
import { RevealCard } from '../RevealCard';
import { QuestionStatusLine } from './QuestionStatusLine';

interface MultipleRevealProps {
  options?: QuestionOption[];
  revealedOptions: number[];
  setRevealedOptions: (number: number) => void;
  /** Cards opened at least once. Drives the per-card check and the progress line. */
  flippedOptionIds?: number[];
}

const hasCardContent = (option: QuestionOption) => Boolean(option.front_text || option.back_text);

export const MultipleReveal: React.FC<MultipleRevealProps> = ({
  options,
  revealedOptions,
  setRevealedOptions,
  flippedOptionIds = revealedOptions,
}) => {
  const cards = (options ?? []).filter(hasCardContent);
  const openedCount = cards.filter((option) => flippedOptionIds.includes(option.id)).length;
  const allOpened = cards.length > 0 && openedCount === cards.length;

  return (
    <div className="w-full flex flex-col">
      <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2">
        {cards.map((option) => (
          <RevealCard
            key={option.id}
            frontText={option.front_text || ''}
            backText={option.back_text || ''}
            isRevealed={revealedOptions.includes(option.id)}
            hasBeenRevealed={flippedOptionIds.includes(option.id)}
            onReveal={setRevealedOptions}
            optionId={option.id}
          />
        ))}
      </div>
      {cards.length > 1 ? (
        <QuestionStatusLine ready={allOpened}>
          {allOpened
            ? `All ${cards.length} opened.`
            : `${openedCount} of ${cards.length} opened. Open each one to continue.`}
        </QuestionStatusLine>
      ) : null}
    </div>
  );
};
